<template>
  <div class="index" @click="h5show = false">
    <div class="index-con">
      <div class="big-title">
        <span> {{ $t("committeebigtitle") }}</span>
      </div>
      <div class="d-flex">
        <div v-for="item in datas">
          <div class="small-title text-green ">{{ item.title }}</div>
          <div class="text">
            <div class="mb-10" v-for="itm in item.children">
              {{ itm.text }}
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="bottom_span"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      datas: [{
        title: 'General Chairs:',
        children: [
          { text: 'Binrui WANG, China Jiliang University, China' },
          { text: 'QingPing YANG, Brunel University of London, UK' }
        ]
      },
      {
        title: 'General Co-Chairs:',
        children: [
          { text: 'Alistair FORBES, National Physical Laboratory, UK ' },
          { text: 'Abdérafi CHARKI, Université d’Angers, France ' },
          { text: 'Yanfu LI, Tsinghua University, China' },
          { text: 'Huijie ZHAO, Beihang University, China' },
          { text: 'Hongzhong HUANG, University of Electronic Sci & Tech of China ' },
        ]
      }, {
        title: 'International Program Committee Co-Chairs:',
        children: [
          { text: 'Valerie LIVINA, National Physical Laboratory, UK' },
          { text: 'Wenyi LIU, North University of China, China' },
          { text: 'Qiang WANG, China Jiliang University, China' },
          { text: 'Xiangjun WANG, Tianjin University, China' },
        ]
      },
      {
        title: 'Advisory Committee:',
        children: [
          { text: 'Yong YAN, Beihang University, China' },
          { text: 'Jinghong LI, Tsinghua University, China' },
          { text: 'Steve DYKE, Mitutoyo(UK) Ltd, UK' },
          { text: 'Barry JONES, Brunel University of London; IET(former Vice President), UK' },
          { text: 'Pete LOFTUS, Evalu8ion Ltd; University of Edinburgh; RCNDE; Sensing Innovation Leadership Council, UK' },
          { text: 'Ian NICHOLSON, TWI, UK' },
          { text: 'Hans RABUS, PTB, Germany' },
        ]
      },
      {
        title: 'International Program Committee Members:',
        children: [

          { text: 'Tianjian LI,  University of Shanghai for Sci and Tech, China' },
          { text: 'Feng LIU, Tianjin University, China' },
          { text: 'Xianping LIU, Warwick University, UK' },
          { text: 'Nila NILAVALAN, Brunel University of London, UK' },
          { text: 'Qunfen QI, University of Bristol, UK' },
          { text: 'Mohd Rizal Bin SALLEH, Universiti Teknikal Malaysia Melaka, Malaysia' },
          { text: 'Thammarat SOMTHONG, Thailand National Institute of Metrology, Thailand' },
          { text: 'Valentina STOJCESKA, Brunel University of London, UK' },
          { text: 'Wenjuan SUN, KU Leuven, Belgium' },
          { text: 'Ivan SUDAKOW, The Open University, UK' },
          { text: 'Xizhi SUN, Brunel University of London, UK' },
          { text: 'Qijian TANG, Shenzhen University, China' },
          { text: 'Zdenek VINTR, University of Defense, Czech Republic' },
          { text: 'Fang WANG, Brunel University of London, UK' },
          { text: 'Hong WEI, University of Reading, UK' },
          { text: 'Decheng WEN, Shandong University, China' },
          { text: 'Mengyuan Zhang, Kingston University, UK' },
        ]
      },
      ],
      h5show: false,
      peopleList: [
        {
          name: "Zhang M.",
          text: "Jiangnan University, Wuxi, P.R. China (IDS 2024 Chairman)",
        },
        {
          name: "Bi J.F.",
          text: "Institute of Food Science and Technology, CAAS, Beijing, P.R. China",
        },
        {
          name: "Chen X.D.",
          text: "Soochow University, Suzhou, P.R. China",
        },
        {
          name: "Duan X.",
          text: "Henan University of Science and Technology, Luoyang, P.R. China",
        },
        {
          name: "Huang L.X.",
          text: "Institute of Chemical Industry of Forest Products, Nanjing, P.R. China",
        },
        {
          name: "Jin J.H.",
          text: "Nanjing Institute for Comprehensive Utilization of Wild Plants, China CO-OP，Nanjing，P.R.China",
        },
        {
          name: "Li D.J.",
          text: "Institute of Agro-product Processing, JAAS, Nanjing, P.R. China",
        },
        {
          name: "Li S.B.",
          text: "Jiangsu BoLaiKe Refrigeration Science and Technology Development Co., Ltd., Changzhou, P.R. China",
        },
        {
          name: "Li Z.Y.",
          text: "Tianjin University of Science and Technology, Tianjin, P.R. China",
        },
        {
          name: "Wang S.J.",
          text: "Northwest A&F University, Yangling, P.R. China",
        },
        {
          name: "Wu Z.H.",
          text: "Tianjin University of Science & Technology, Tianjin, P.R. China",
        },
        {
          name: "Xiao H.W.",
          text: "China Agricultural University, Beijing, P.R. China",
        },
        {
          name: "Yu D.X.",
          text: "SOHAO FD-TECH CO., LTD., Qingdao, P.R. China",
        },
        {
          name: "Zha G.C.",
          text: "Changzhou Yibu Drying Equipment Co., Ltd., Changzhou, P.R. China",
        },
        {
          name: "Zhou C.S.",
          text: "Jiangsu University, Zhenjiang, P.R. China",
        },
      ],
      tableData: [
        {
          date: "1",
          name: "Mujumdar A.S. (Canada)",
          address: "Devahastin S. (Thailand)",
        },
        {
          date: "2",
          name: "Abdelghani, B. (Algeria)",
          address: "Abdenouri, N. (Morocco)",
        },
        {
          date: "3",
          name: "Akinola A. (Nigeria)",
          address: "Alves-Filho O. (Norway)",
        },
        {
          date: "4",
          name: "Andrieu J. (France)",
          address: "Barresi A. (Italy)",
        },

        {
          date: "5",
          name: "Bruttini R. (Italy)",
          address: "Bhandari B. (Australia)",
        },
        {
          date: "6",
          name: "Chen G. (Hong Kong, P.R. China)",
          address: "Chen X. D. (P.R. China)",
        },
        {
          date: "7",
          name: "Farkas I. (Hungary)",
          address: "Emam-Djomeh Z. (Iran)",
        },

        {
          date: "8",
          name: "Itaya Y. (Japan)",
          address: "Fortes M. (Brazil)",
        },
        {
          date: "9",
          name: "Kemp I. (UK)",
          address: "Kechaou N. (Tunisia)",
        },
        {
          date: "10",
          name: "Krokida M. (Greece)",
          address: "Kowalski S. (Poland)",
        },

        {
          date: "11",
          name: "Langrish T. (Australia)",
          address: "Kudra T. (Canada)",
        },
        {
          date: "12",
          name: "Leonard A. (Belgium)",
          address: "Law C.L. (Malaysia)",
        },
        {
          date: "13",
          name: "Miao S. (Ireland)",
          address: "Levy A. (Israel)",
        },

        {
          date: "14",
          name: "Opara L. (South Africa)",
          address: "Mulet A. (Spain)",
        },
        {
          date: "15",
          name: "Pang S. (New Zealand)",
          address: "Pakowski Z. (Poland)",
        },
        {
          date: "16",
          name: "Perré P. (France)",
          address: "Peczalski R. (France)",
        },
        {
          date: "17",
          name: "Rodriguez-Ramirez (Mexico)",
          address: "Raghavan V. (Canada)",
        },
        {
          date: "18",
          name: "Rosello C. (Spain)",
          address: "Renstrom R. (Sweden)",
        },

        {
          date: "19",
          name: "Prachayawarakorn S. (Thailand)",
          address: "Sarkar Md. S.H. (Bangladesh)",
        },
        {
          date: "20",
          name: "Sihem, B. (Tunisia)",
          address: "Schutyser M. (Netherlands)",
        },

        {
          date: "21",
          name: "Thorat B. (India)",
          address: "Taranto O. (Brazil)",
        }, {
          date: "22",
          name: "Tsotsas E. (Germany)",
          address: "Timofeev O. (Finland) ",
        }, {
          date: "23",
          name: "Zbicinski I. (Poland)",
          address: "Yagoobi J. (USA)",
        }, {
          date: "24",
          name: "Zhou W. (Singapore)",
          address: "Zhang, M. (P.R. China) ",
        },
      ],
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
  },
};
</script>

<style scoped>
.text-green {
  color: #0270c0 !important;
}

.mb-10 {
  margin-bottom: 10px;
}

.d-flex {
  display: flex;
  flex-wrap: wrap;
}

.d-flex>div {
  width: 50%;
}

.mt-50 {
  margin-top: 50px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.bottom_span {
  padding-top: 80px;
}

.imgcenter {
  width: 100%;
  padding: 20px 200px 20px 200px;
}

.imgcenter img {
  width: 70%;
}

.top {
  /*position: fixed;*/
  top: 150px;
  left: 0;
  background: #fff;
  height: 70px;
  box-sizing: border-box;
  z-index: 99;
  width: 100%;
  border-top: 10px solid #0a9a7a;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 390px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.navbg {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.text {
  color: #333;
  /* text-indent: 2em; */
  /* padding-left: 2em; */
  line-height: 2;
  padding-bottom: 20px;
}

.img {
  width: 50%;
  height: auto;
}

.people-lists p {
  display: flex;
  margin-bottom: 6px;
}

.people-lists p span {
  display: inline-block;
  width: 50%;
}

.top-bg {
  background-image: url("https://img0.baidu.com/it/u=2363835659,3802656139&fm=253&fmt=auto&app=138&f=JPEG?w=1180&h=492");
  background-size: 100% auto;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
}

.bannerbg {
  width: 100%;
  height: 150px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  background: rgba(255, 255, 255, 0.5);
  justify-content: space-between;
}

.aboutcom {
  padding-right: 150px;
  flex: 1;
}

.aboutcomtitle1 {
  font-size: 25px;
  color: #000;
  padding-top: 20px;
}

.aboutcomtitle2 {
  font-size: 18px;
  color: #413939ad;
}

.language {
  display: flex;
}

.language1 {
  padding-top: 10px;
}

.language2 {
  padding: 10px 10px 0 10px;
}

.nav {
  color: #0a9a7a;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.nav span {
  padding: 0 15px;
  box-sizing: border-box;
  line-height: 50px;
  display: inline-block;
  cursor: pointer;
  font-size: 16px;
}

.nav span:hover,
.nav .active {
  color: #04551f;
  font-weight: 500;
  transition: 0.3s all;
  border-bottom: 2px solid #0a9a7a;
}

.h5-menu {
  text-align: right;
  padding: 15px;
  box-sizing: border-box;
  display: none;
  position: relative;
}

.el-icon-menu {
  font-size: 24px;
  color: #0a9a7a;
}

@media screen and (max-width: 768px) {
  .bannerbg img {
    height: 70px;
  }

  .bannerbg {
    display: block;
  }

  .language {
    position: relative;
    left: 20px;
    top: 20px;
  }

  .d-flex {
    display: block;
  }

  .d-flex>div {
    width: 100%;
  }

  .aboutcom {
    display: none;
    padding-right: 10px;
  }

  .h5-menu {
    display: block;
  }

  .h5-nav {
    position: absolute;
    background: #fff;
    top: 100%;
    border: 1px solid #ddd;
    box-shadow: 3px 3px 4px #ddd;
    right: 10px;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
  }

  .h5-title {
    text-align: right;
  }

  .h5-nav p {
    height: 36px;
    display: flex;
    border-bottom: 1px dashed #eee;
    align-items: center;
  }

  .h5-nav p.active {
    color: #04551f;
    font-weight: 600;
  }

  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .navbg {
    display: none;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/committee.vue